import type { StoreService } from '@/hooks/store';
import { createColumnHelper } from '../appTable';

const columnHelper = createColumnHelper<StoreService>();

export const storeServiceColumns = columnHelper.columns([
  columnHelper.accessor('name', {
    id: 'id',
    cell: (info) => info.getValue(),
    filterFn: 'includesString',
    header: 'Name',
    meta: { filterVariant: { type: 'singleSearch' } },
  }),
  columnHelper.accessor((row) => row.tags.length, {
    id: 'tagCount',
    cell: (info) => info.getValue(),
    header: 'Tags',
  }),
  columnHelper.accessor((row) => row.tags[0]?.tag ?? '-', {
    id: 'latestTag',
    cell: (info) => info.getValue(),
    header: 'Latest Tag',
  }),
]);
